module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0056.jpg?v=12992877";